import { z } from 'zod';

export const duplicarTorneioSchema = z.object({
  nome: z.string().min(1, 'Nome é obrigatório'),
  username: z.string().min(1, 'Username é obrigatório'),
  dataInicio: z.string().min(1, 'Data de início é obrigatória'),
  dataFim: z.string().min(1, 'Data de fim é obrigatória'),
  dataInscricaoInicio: z.string().min(1, 'Data de início de inscrição é obrigatória'),
  dataInscricaoFim: z.string().min(1, 'Data de fim de inscrição é obrigatória'),
}).refine((data) => {
  if (!data.dataInicio || !data.dataFim) return true;
  return new Date(data.dataInicio) <= new Date(data.dataFim);
}, {
  message: 'Data de início não pode ser maior que a data de fim',
  path: ['dataInicio'],
}).refine((data) => {
  if (!data.dataInscricaoInicio || !data.dataInscricaoFim) return true;
  return new Date(data.dataInscricaoInicio) <= new Date(data.dataInscricaoFim);
}, {
  message: 'Data de início de inscrição não pode ser maior que a data de fim de inscrição',
  path: ['dataInscricaoInicio'],
});

export type DuplicarTorneioFormValues = z.infer<typeof duplicarTorneioSchema>;
